import { makeStyles } from "@fluentui/react-components";
import Introduction from "./Introduction";
import TeamMembers from "./TeamMembers";
import Separation from "./Separation";
import Location from "./Location";
import Partners from "./Partners";
import CEO from "./CEO";
import Hero from "../../../components/hero/Hero";
import { useTranslation } from "react-i18next";
import SEO from "../../../app/SEO";
import { useHeroMainSnap } from "../../../hooks/useHeroMainSnap";
import Certifications from "../../../layout/footer/Certifications";

const useStyles = makeStyles({
    consultancySection: { 
        padding: "1rem 0",
        backgroundColor: "white"
    },
    certificationsSection: {
        backgroundColor: "white",
        maxWidth: "1200px",
        margin: "2rem auto",
        boxSizing: "border-box"
    },
    certificationsTitle: {
        fontSize: "2rem",
        fontWeight: 400,
        color: "#333",
        lineHeight: 1.3,
        margin: 0
    }
});

const OurStory = () => {
    const { t } = useTranslation("ourstory");
    const styles = useStyles();

    // snap behaviour for this page
    useHeroMainSnap("ourstory-hero", "ourstory-main", {
        duration: 900,
        easing: "quart",
        heroCapturePx: 80,
        upCapturePx: 300,
        headerOffset: 0
    });

    const jsonLD = [
        {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: t("pageTitle"),
            publisher: {
                "@type": "Organization",
                name: t("general.companyNane")
            }
        }
    ];

    return (
        <>
            <SEO
                title={{ title: t("pageTitle"), pageTitle: t("pageTitle") }}
                canonicalPath="/ourstory"
                jsonLD={jsonLD}
            />

            <div id="ourstory-hero">
                <Hero
                    title={t("hero.title")}
                    subtitle={t("hero.description")}
                    imageUri="/img/banners/our-story.png"
                />
            </div>

            <div id="ourstory-main">
                <section className={styles.consultancySection}>
                    <Introduction />
                    <section className={styles.certificationsSection}>
                        <Certifications />
                    </section>
                    <Separation />
                </section>

                <Location />
                <Partners />
                <CEO />
                <TeamMembers />
            </div>
        </>
    );
};

export default OurStory;
